import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { LoginNavbar } from '../../components/layout/Navbar';

const Footer = ({ className }) => (
  <footer className={className || 'footer'}>
    @ EZ Timesheet Copyright Reserved
  </footer>
);

const Home = () => {
  return (
    <>
      <LoginNavbar />
      <div className="home-container">
        <div className="home-back-button">
          <Link to="/login" className="back-button">
            ← Back to Login
          </Link>
        </div>
        <div className="home-hero">
          <div className="home-hero-content">
            <h1 className="home-title">EZ Timesheet</h1>
            <p className="home-subtitle">
              Streamline your time tracking and expense management with our powerful, 
              user-friendly platform designed for modern businesses.
            </p>
            <div className="home-cta-buttons">
              <Link to="/login" className="home-cta-primary">
                Get Started
              </Link>
              <Link to="/about" className="home-cta-secondary">
                Learn More
              </Link>
            </div>
          </div>
          <div className="home-hero-image">
            <div className="home-image-placeholder">
              <span>Timesheet Dashboard Preview</span>
            </div>
          </div>
        </div>

        <div className="home-features">
          <div className="home-features-header">
            <h2>Why Choose EZ Timesheet?</h2>
            <p>Powerful features designed to make time management effortless</p>
          </div>
          
          <div className="home-features-grid">
            <div className="home-feature-card">
              <div className="home-feature-icon">⏰</div>
              <h3>Easy Time Tracking</h3>
              <p>Record time with just a few clicks. Our intuitive interface makes time tracking simple and accurate.</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">💰</div>
              <h3>Expense Management</h3>
              <p>Track expenses, submit reports, and get approvals through our streamlined workflow system.</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">📊</div>
              <h3>Advanced Reporting</h3>
              <p>Generate comprehensive reports and gain insights into productivity, project costs, and team performance.</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">🔒</div>
              <h3>Secure & Reliable</h3>
              <p>Your data is protected with enterprise-grade security and backed up with 99.9% uptime guarantee.</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">📱</div>
              <h3>Mobile Friendly</h3>
              <p>Access your timesheets and expenses from anywhere with our responsive mobile design.</p>
            </div>
            
            <div className="home-feature-card">
              <div className="home-feature-icon">👥</div>
              <h3>Team Collaboration</h3>
              <p>Work together seamlessly with team management features and real-time updates.</p>
            </div>
          </div>
        </div>

        <div className="home-stats">
          <div className="home-stats-content">
            <div className="home-stat">
              <div className="home-stat-number">10,000+</div>
              <div className="home-stat-label">Active Users</div>
            </div>
            <div className="home-stat">
              <div className="home-stat-number">500+</div>
              <div className="home-stat-label">Companies</div>
            </div>
            <div className="home-stat">
              <div className="home-stat-number">99.9%</div>
              <div className="home-stat-label">Uptime</div>
            </div>
            <div className="home-stat">
              <div className="home-stat-number">24/7</div>
              <div className="home-stat-label">Support</div>
            </div>
          </div>
        </div>

        <div className="home-cta-section">
          <div className="home-cta-content">
            <h2>Ready to Transform Your Time Management?</h2>
            <p>Join thousands of organizations already using EZ Timesheet to improve productivity and reduce administrative overhead.</p>
            <Link to="/login" className="home-cta-button">
              Start Your Free Trial
            </Link>
          </div>
        </div>
      </div>
      <Footer className="home-footer" />
    </>
  );
};

export default Home; 